import { Directive, ElementRef, HostBinding, Input, Optional } from '@angular/core';
import { Router, RouterLink, RouterLinkWithHref } from '@angular/router';
import { RelService } from '@df/core/meta/router/rel.service';

/**
 * A directive that sets the `rel` attribute of an anchor element based on its href value.
 */
@Directive({
    selector: 'a',
    standalone: true
})
export class ADirective {
    /**
     * A href
     */
    @Input()
    href: string | undefined;

    constructor(
        private relService: RelService,
        private router: Router,
        @Optional() private routerLink: RouterLink,
        @Optional() private routerLinkWithHref: RouterLinkWithHref,
        private el: ElementRef
    ) {}

    /**
     * Rel to set
     */
    @HostBinding('attr.rel')
    get rel(): string | undefined {
        const currentRel = this.el.nativeElement.getAttribute('rel');
        if (currentRel) {
            return currentRel;
        }
        return this.relService.getRel(this.getHref());
    }

    /**
     * Update rel
     */
    private getHref(): string | undefined {
        if (this.href) {
            return this.href;
        }

        if (this.routerLink?.urlTree) {
            return this.router.serializeUrl(this.routerLink.urlTree);
        }

        if (this.routerLinkWithHref?.href) {
            return this.routerLinkWithHref.href;
        }

        return undefined;
    }
}
